import { cloneDeep } from 'lodash';

import { RequiredActionCondition, ConditionStatus } from '@funnels/types';

export const REQUIRED_ACTION_CONDITION_MOCK_DATA: RequiredActionCondition[] = [
  {
    applicationId: '6652dd47-b3ae-42a5-86d1-f43c058d4d1b',
    comment: null,
    detail: {
      allowBrokerMitigation: true,
      allowCustomerMitigation: false,
      commentRequired: true,
      description: 'Applicants have the option to choose the delivery method of their loan documents.',
      hardstop: false,
      includedInCoversheet: false,
      mitigationDescription:
        'Does the customer have issues with accessing a printer to print documents? If none, documents will be emailed by default.',
      override: true,
      requiredDocTypes: [],
      ruleCategory: 'Submission',
      ruleId: '61feb039-5c39-4404-99f9-4144686d3f8e',
      ruleName: 'Loan Documents Delivery',
      ruleVersion: 2,
      selectedLenderId: '528756f9-6187-493e-861d-39c93cb3359f',
      variationOnly: false,
    },
    id: '02fa1a72-f934-47b0-b058-2aa735257fdf',
    requiredDocuments: [],
    status: ConditionStatus.Opened,
    version: 2,
  },
  {
    applicationId: '6652dd47-b3ae-42a5-86d1-f43c058d4d1b',
    comment: null,
    detail: {
      allowBrokerMitigation: true,
      allowCustomerMitigation: false,
      commentRequired: true,
      description: 'Verify finance and settlement dates are in line with the Lender SLA.',
      hardstop: false,
      includedInCoversheet: true,
      mitigationDescription: 'Obtain the solicitor details, finance due date & settlement date. ',
      override: true,
      requiredDocTypes: [],
      ruleCategory: 'Submission',
      ruleId: '06bc0787-fdbc-48a6-9d3a-82ae2741f928',
      ruleName: 'Finance Date & Settlement Details',
      ruleVersion: 2,
      variationOnly: false,
    },
    id: '0373bfe7-7cef-47f0-aa7e-635de166dfd5',
    requiredDocuments: [],
    status: ConditionStatus.SystemMitigated,
    version: 2,
  },
];

export const getMockRequiredActionConditions = (): RequiredActionCondition[] =>
  cloneDeep(REQUIRED_ACTION_CONDITION_MOCK_DATA);
